import React, { FunctionComponent, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "../../../redux/app/hooks";
import { login, setLoginPage, setLoginUser, setTeacherMainRoute, setSchoolType } from "../../../redux/slices/authSlice";
import { CheckCircle } from "@mui/icons-material";
import Loader from "../../../components/Loader/Loader";
import "./PaymentStatus.scss";

const PaymentSuccess: FunctionComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 20000);
    return () => clearTimeout(timer);
  }, []);

  const handleContinue = () => {
    const queryParams = new URLSearchParams(location.search);
    const from = queryParams.get("from");
    const accessToken = localStorage.getItem(Object.keys(localStorage).find((key) => key.includes("accessToken")) as string) || "";

    // If payment was triggered from the login flow (scenario B)
    if (from === "login" || accessToken) {
      localStorage.removeItem("registered_username");
      dispatch(setLoginPage({ loginPage: "student" }));
      dispatch(login({ role: "student" }));
      dispatch(setLoginUser({ loginAs: "student" }));
      dispatch(setTeacherMainRoute({ teacherMainRoute: "/student-verifyCode" }));
      dispatch(setSchoolType({schoolType: 'VIRTUAL'}));
      navigate("/student-verifyCode");
    } else {
      // If payment was triggered from registration flow (scenario A)
      navigate("/virtual-school/virtual-login", { state: { prefillUsername: true } });
    }
  };

  if (isLoading) {
    return (
      <div className="paymentStatusCtn">
        <div className="paymentLoaderCard">
          <Loader />
          <p className="paymentPleaseWait">Confirming payment. Please wait...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="paymentStatusCtn">
      <div className="paymentCard">
        <div className="successIconOuter">
          <div className="successIconInner">
            <CheckCircle />
          </div>
        </div>
        <h2 className="statusTitle">Payment Successful</h2>
        <p className="statusDescription">
          Thank you! Your payment has been successfully processed and your class access is ready. Click below to continue.
        </p>
        <div className="actionBtnRow">
          <button onClick={handleContinue}>Explore</button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
